export default {
  data() {
    return {
      axios: axios.create({
        headers: { 'Authorization': this.$root.authToken }
      })
    }
  },
  methods: {

  },
  created() {
    //
  }
}
